import React from "react";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const UserList = ({
  filteredUsers,
  handleEditUser,
  handleDeleteUser,
  currentPage,
  setCurrentPage,
  usersPerPage,
}) => {
  // Mapping role_id to readable user type
  const getRoleName = (roleId) => {
    switch (roleId) {
      case "1":
        return "Admin";
      case "2":
        return "Manager";
      case "3":
        return "Employee";
      default:
        return "Unknown";
    }
  };
  const getStatusName = (status) => {
    return status === "1" ? "Active" : "Inactive";
  };

  const handlePageChange = (direction) => {
    setCurrentPage((prev) =>
      Math.min(
        Math.max(prev + direction, 1),
        Math.ceil(filteredUsers.length / usersPerPage)
      )
    );
  };

  return (
    <div className="UserList MenuList">
      <table>
        <thead>
          <tr>
            <th>S.N.</th>
            <th>Full Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Username</th>
            <th>User Type</th>
            <th>Status</th>
            <th className="Actionsss">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers
            .slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage)
            .map((user, index) => (
              <tr key={user.id}>
                <td>{(currentPage - 1) * usersPerPage + index + 1}</td>
                <td>{user.full_name}</td>
                <td>{user.contact}</td>
                <td>{user.email}</td>
                <td>{user.user_name}</td>
                <td>{getRoleName(user.role_id)}</td>
                <td>{getStatusName(user.status)}</td>
                <td className="Actionsss">
                  <Button onClick={() => handleEditUser(user)}>
                    <EditIcon />
                  </Button>
                  <Button onClick={() => handleDeleteUser(user.id)}>
                    <DeleteIcon />
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <div className="Pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(-1)}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {Math.ceil(filteredUsers.length / usersPerPage)}
        </span>
        <button
          disabled={
            currentPage === Math.ceil(filteredUsers.length / usersPerPage)
          }
          onClick={() => handlePageChange(1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default UserList;
